import {
  BackgroundColors,
  NegativeColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Easing } from '@picsart/design-system/foundation/easing';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';

const useStyles = createUseStyles(
  () => ({
    wrapper: {
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      transition: `border ${Timings.default} ${Easing.linear}`,
      padding: [Spacings.s24, Spacings.s32, Spacings.s32],
      height: 'fit-content',
      width: '100%',
      marginBottom: Spacings.s24,
      border: `1px solid ${BackgroundColors.tint3}`,
      borderRadius: CornerRadius.r12,

      '&.interactive': {
        cursor: 'pointer',

        '&:hover': {
          border: `1px solid ${NegativeColors.base.default}`,
        },
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        padding: Spacings.s24,
      },
    },
    itemTitle: {
      marginBottom: Spacings.s16,
      fontSize: FontSizes.s24,
      lineHeight: LineHeights.l32,
      color: TextColors.base,
      textAlign: 'left',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s8,
        fontSize: FontSizes.s8,
        lineHeight: LineHeights.l28,
      },
    },
    itemDescription: {
      lineHeight: LineHeights.l24,
      fontSize: FontSizes.s14,
      color: NegativeColors.base.activeAction,
      textAlign: 'left',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        lineHeight: LineHeights.l20,
      },
    },
  }),
  {
    name: 'box',
  },
);

export default useStyles;
